export enum AnalyticsQueryTypes {
  ENGAGEMENT = "engagement",
  COUNTS = "counts",
  DSPS = "dsps",
  SONGS = "songs",
  AGE = "age",
  GENDER = "gender",
  LOCATIONS = "locations",
}

export type PathParameters = {
  artistId: string;
  queryType: AnalyticsQueryTypes
}

export type QueryStringParameters = {
    start: number;
    end: number;
    dsps: string;
    range: string;
}
